mutation InitiateSsoSetup {
    initiateSsoSetup {
        redirectUrl
    }
}
